<script lang="ts" generic="TItem" setup>
import VueDraggable from 'vuedraggable';
import Flex from '../utils/Flex.vue';
import type { Header } from '../helpers';

interface Props
{
    showHeader: boolean;
    headers: Header[];
    rows: TItem[];
    pager: Pager;
}

defineOptions({
    name: 'ListViewFlexLayout',
    inheritAttrs: false
});

const props = withDefaults(defineProps<Props>(), {});
const emptyLabel = inject<string>('empty-label');
const $attrs = useAttrs();
const attrs = (): Record<string, any> => only($attrs, 'class', 'style');

const onDrag = inject<(items: TItem[]) => void>('onDrag');
const draggable = inject<boolean>('draggable');

const canSort = (): boolean =>
{
    return draggable;
};

const items = computed({
    get()
    {
        return props.rows;
    },
    set(value: TItem[])
    {
        onDrag(value);
    }
});
</script>

<template>
    <div v-bind="attrs()">
        <VueDraggable
            v-model="items"
            :item-key="(el: TItem, index: number) => index"
            draggable=".draggable"
            :move="canSort"
        >
            <template #item="{ element: item, index }: { element: TItem, index: number}">
                <Flex :index="index" :item="item" :headers="props.headers">
                    <slot name="row" :item="item" :index="index" />
                </Flex>
            </template>
        </VueDraggable>
        <div v-if="rows.length == 0">
            <div class="text-center p-3 mt-1 mb-3 bg-body-tertiary">
                {{ $t(emptyLabel) }}
            </div>
        </div>
    </div>
</template>
